import { useEffect, useState } from 'react';
import api from '../services/api.js';

/**
 * Public runtime configuration from the API (/api/public/config): whether this is a demo environment
 * and which parts are simulated. Fetched once per page load and shared; every field has a safe default
 * so pages work unchanged if the endpoint is unavailable.
 */
export const DEFAULT_PUBLIC_CONFIG = {
  demoMode: false,
  sessionHoldAmount: 300,
  guestHoldAmount: 500,
  mockPayments: false,
  mockChargers: false,
  notificationsSimulated: false,
};

let cached = null;
let pending = null;

export function loadPublicConfig() {
  if (cached) return Promise.resolve(cached);
  if (!pending) {
    pending = api
      .publicConfig()
      .then((c) => { cached = { ...DEFAULT_PUBLIC_CONFIG, ...(c || {}) }; return cached; })
      .catch(() => { pending = null; return DEFAULT_PUBLIC_CONFIG; });
  }
  return pending;
}

export function usePublicConfig() {
  const [config, setConfig] = useState(cached || DEFAULT_PUBLIC_CONFIG);
  useEffect(() => {
    let live = true;
    loadPublicConfig().then((c) => live && setConfig(c));
    return () => { live = false; };
  }, []);
  return config;
}
